/**
 * @file stubs.ts
 * Stub client implementations for SDK modules that are planned for future sprints.
 *
 * These stubs provide the correct type signatures so that TypeScript compiles,
 * but throw at runtime until the real backend endpoints are implemented.
 * Each stub method logs a warning to the console.
 *
 * Modules:
 *  - AuditClient     → Sprint OPS-02 (security events, ledger, trace)
 *  - SessionsClient  → Sprint P1 (file upload sessions, results)
 *  - SuspensionsClient → Sprint HITL-02 (pending dossiers, validation)
 *  - ChatClient      → Sprint P1 (real-time SSE chat subscriptions)
 *  - BricksClient    → Demo mode only (clause generator / compliance validator)
 */
// ── Helpers ─────────────────────────────────────────────────────────────────
function notImplemented(method) {
    console.warn(`[AssistiaSDK] ${method} is a stub — not yet implemented.`);
    throw new Error(`${method} is not yet implemented. This module is planned for a future sprint.`);
}
function stubResponse(data) {
    return { data, simulated: true };
}
// ── Audit ───────────────────────────────────────────────────────────────────
//
// The frontend (AuditPage.tsx) defines its own local types for SecurityEvent,
// LedgerEvent, and TraceDetail. The SDK stub uses `any` to avoid coupling the
// SDK types to the frontend types until the real backend implementation lands.
export class AuditClientStub {
    _http;
    constructor(_http) {
        this._http = _http;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async listSecurityEvents() {
        return stubResponse([]);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async listLedgerEvents() {
        return stubResponse([]);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async getTrace(traceId) {
        return stubResponse({ trace_id: traceId, events: [] });
    }
}
export class SessionsClientStub {
    _http;
    constructor(_http) {
        this._http = _http;
    }
    async upload(_file) {
        return notImplemented('sessions.upload');
    }
    async getResult(_dossierId) {
        return notImplemented('sessions.getResult');
    }
}
export class SuspensionsClientStub {
    _http;
    constructor(_http) {
        this._http = _http;
    }
    async getPending(_classificationFilter, _docTypeFilter) {
        return stubResponse({ dossiers: [] });
    }
    async validate(_dossierId, _approved, _comment) {
        return notImplemented('suspensions.validate');
    }
}
export class ChatClientStub {
    _baseUrl;
    constructor(_baseUrl) {
        this._baseUrl = _baseUrl;
    }
    /**
     * Subscribe to real-time events for a dossier.
     * Returns an unsubscribe function.
     */
    subscribe(_dossierId, _onEvent, _onDisconnect) {
        console.warn('[AssistiaSDK] chat.subscribe is a stub — no events will be emitted.');
        return () => { };
    }
}
// BricksClientStub supprimé — SDK-01 (2026-06-19) : bricks retirés de l'API.
//# sourceMappingURL=stubs.js.map